module.exports = new __parcel__URL__("add-on-v1-darkmode.d24e726f.svg").toString();